// eslint-disable-next-line max-classes-per-file
class NotAuthenticatedError extends Error {}
class ClientClosedRequestError extends Error {}
class NotFoundError extends Error {}
class ServerError extends Error {}

const HTTP_ERROR_RESPONSES = {
  CLIENT_CANCELLED : {
    status      : 499,
    heading     : 'Request Closed by Client ',
    description : 'Client was unable to complete the request',
  },
  NOT_AUTHENTICATED : {
    status      : 401,
    heading     : 'Unauthorized Access',
    description : 'Your session may have expired or you are not authorized to view this page.',
  },
  SERVER_ERROR : {
    status      : 500,
    heading     : 'Something went wrong',
    description : `An unexpected error occurred and your request couldn't be handled. Please refresh the page. If the problem persists, please try again later.`,
  },
  NOT_FOUND : {
    status      : 404,
    heading     : 'Something went wrong',
    description : `Resource not `,
  },
  UNKNOWN_ERROR : { // TODO: update copy if we want to make it look different from server error
    status      : 500,
    heading     : 'Something went wrong',
    description : `An unexpected error occurred and your request couldn't be handled. Please refresh the page. If the problem persists, please try again later.`,
  },
};

const serverErrorHandler = (error, callback) => {
  if (error instanceof ClientClosedRequestError) {
    callback(HTTP_ERROR_RESPONSES.CLIENT_CANCELLED);
  } else if (error instanceof NotAuthenticatedError) {
    callback(HTTP_ERROR_RESPONSES.NOT_AUTHENTICATED);
  } else if (error instanceof ServerError) {
    callback(HTTP_ERROR_RESPONSES.SERVER_ERROR);
  } else if (error instanceof NotFoundError) {
    callback(HTTP_ERROR_RESPONSES.NOT_FOUND);
  } else {
    callback(HTTP_ERROR_RESPONSES.UNKNOWN_ERROR);
  }
};

export {
  HTTP_ERROR_RESPONSES,
  serverErrorHandler,
  NotAuthenticatedError,
  NotFoundError,
  ClientClosedRequestError,
  ServerError,
};
